/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import ReactLazyLoad from "react-lazyload";
import { observer } from "mobx-react";
import { withStores } from "stores";
import {
  CustomerNotification as InlineNotification,
  CustomerNotificationLocation as InlineNotificationLocation,
  CustomerNotificationStateEvent,
} from "@shared-ui/customer-notifications";
import { useProvidedState } from "@shared-ui/provided-state-context";
import { checkValue } from "src/components/common/helper";

// Css Style Import
import(/* webpackChunkName: "mad-marque-styles" */ 'src/components/common/modules/mad-marque/styles/mad-marque.css');

const optionalSiteIds = {
  expedia: "Homepage",
  vrbo: "page.App",
  hotels: "HCOM.APP.MAD",
}

export const MadMarquee = withStores( 
  "context",  
  "page"
)(
  observer((props: any) => {
    const {context: {site: { brand }}} = props
    const inlineNotification = (
      <InlineNotification
        inputs={{
          xPageId: optionalSiteIds[brand] || "page.App",
          notificationLocation: InlineNotificationLocation.FOOTER,
        }}
        skipSsr={true}
      />
    );

    return (

      <ReactLazyLoad once offset={200}>
        {checkValue(inlineNotification) && (<div className='mad-marquee-content container-fluid' data-testid="mad-marquee-container">
          <div className='container'>
            {inlineNotification}
          </div>
        </div>)}
      </ReactLazyLoad>

    );
  })
);

export default MadMarquee;